import HttpClient from './http.js'

// 创建默认的HTTP客户端实例
const http = new HttpClient('/erp', {
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json'
  }
})

// 添加请求拦截器
http.addRequestInterceptor(
  // 成功回调
  (config) => {
    // 添加认证token - 收银系统使用x-token
    const token = localStorage.getItem('token')
    if (token) {
      config.headers['x-token'] = token
    }

    // 添加请求时间戳
    config.headers['X-Request-Time'] = Date.now()

    console.log('请求发送:', config.method?.toUpperCase(), config.url)
    return config
  },
  // 失败回调
  (error) => {
    console.error('请求拦截器错误:', error)
    return Promise.reject(error)
  }
)

// 添加响应拦截器
http.addResponseInterceptor(
  // 成功回调
  async (response) => {
    console.log('响应接收:', response.status, response.url)

    // 克隆响应以便多次读取
    const clonedResponse = response.clone()

    try {
      const data = await response.json()

      // 检查HTTP状态码
      if (!response.ok) {
        throw new Error(`HTTP Error: ${response.status} ${response.statusText}`)
      }

      // 处理业务错误码 (收银系统API统一格式: 0成功, 7失败)
      if (data.code === undefined) {
        // 如果没有code字段，返回原始数据
        return {
          success: true,
          data: data,
          message: data.msg || 'success',
          code: 0
        }
      }

      // 统一处理code字段
      if (data.code === 0) {
        // 成功
        return {
          success: true,
          data: data.data || data,
          message: data.msg || 'success',
          code: data.code
        }
      } else {
        // 业务失败，直接返回失败结果而不是抛出错误
        return {
          success: false,
          code: data.code,
          message: data.msg || '业务错误',
          data: data.data
        }
      }

    } catch (error) {
      // 如果是HTTP错误，处理网络错误
      if (error.message.includes('HTTP Error:')) {
        const match = error.message.match(/HTTP Error: (\d+)/)
        const errorCode = match ? parseInt(match[1]) : 500
        let errorMessage = '请求失败'

        switch (errorCode) {
          case 400:
            errorMessage = '请求参数错误'
            break
          case 401:
            errorMessage = '未授权，请重新登录'
            // 清除本地token
            localStorage.removeItem('token')
            break
          case 403:
            errorMessage = '拒绝访问'
            break
          case 404:
            errorMessage = '请求的资源不存在'
            break
          case 500:
            errorMessage = '服务器内部错误'
            break
          default:
            errorMessage = `请求失败: ${errorCode}`
        }

        return {
          success: false,
          code: errorCode,
          message: errorMessage
        }
      }

      // 如果不是JSON格式，直接返回文本
      try {
        const text = await clonedResponse.text()
        return {
          success: true,
          data: text,
          message: 'success',
          code: 0
        }
      } catch (textError) {
        // 连文本都解析不了
        return {
          success: true,
          data: '',
          message: 'success',
          code: 0
        }
      }
    }
  },
  // 失败回调
  (error) => {
    console.error('响应拦截器错误:', error)

    // 处理网络错误等其他错误
    let errorMessage = '请求失败'
    let errorCode = 500

    if (error.message.includes('HTTP Error:')) {
      // HTTP错误
      const match = error.message.match(/HTTP Error: (\d+)/)
      errorCode = match ? parseInt(match[1]) : 500

      switch (errorCode) {
        case 400:
          errorMessage = '请求参数错误'
          break
        case 401:
          errorMessage = '未授权，请重新登录'
          // 清除本地token
          localStorage.removeItem('token')
          // 可以跳转到登录页
          break
        case 403:
          errorMessage = '拒绝访问'
          break
        case 404:
          errorMessage = '请求的资源不存在'
          break
        case 500:
          errorMessage = '服务器内部错误'
          break
        default:
          errorMessage = `请求失败: ${errorCode}`
      }
    } else if (error.message === 'Request timeout') {
      errorMessage = '请求超时'
      errorCode = 408
    } else if (error.message === 'Failed to fetch') {
      errorMessage = '网络连接失败，请检查网络'
      errorCode = 0
    }

    return Promise.reject({
      success: false,
      message: errorMessage,
      code: errorCode,
      originalError: error
    })
  }
)

export default http